export function debug(msg: string) {
  if (process.env.NODE_ENV == 'production') {
    return
  }

  console.log('[nameql]', msg)
}


// WEBPACK FOOTER //
// ./src/service/logger.ts